/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosErrorMiddleware } from '@requests/common';
import { apiClient } from '@store/index';
import { ResourcePermission, UUID, WorkspaceUser } from '@store/types';

export type PermissionGroup = {
  id: string;
  role_name: string;
  creator: string;
  resources: ResourcePermission[];
};

export const listWorkspaceUsers = async ({ queryKey }: any): Promise<WorkspaceUser[]> => {
  const { serviceId } = queryKey?.[1];
  const response = await apiClient.get(`/${serviceId}/roles`);
  return response.data;
};

// Gets a list of all roles that were created in a workspace by a user in the organization
export const listWorkspaceRoles = async ({ queryKey }: any) => {
  const { serviceId } = queryKey?.[1];
  const response = await apiClient.get(`/${serviceId}/roles/workspace`);
  const roles = response.data as PermissionGroup[];

  // sort alphabetically
  return roles.sort((a, b) => a?.role_name?.localeCompare(b?.role_name));
};

export const editWorkspaceRole = async ({ serviceId, group }: { serviceId: string; group: PermissionGroup }) => {
  try {
    const response = await apiClient.patch(`/${serviceId}/roles`, { group });
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};

export const createWorkspaceRole = async ({
  serviceId,
  roleName,
  resourcePermissions,
}: {
  serviceId: string;
  roleName: string;
  resourcePermissions: UUID[];
}) => {
  try {
    const response = await apiClient.post(`/${serviceId}/roles`, {
      role_name: roleName,
      resource_permissions: resourcePermissions,
    });
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};

export const deleteWorkspaceRole = async ({ serviceId, roleId }: { serviceId: string; roleId: string | null }) => {
  try {
    const response = await apiClient.delete(`/${serviceId}/roles?roleId=${roleId}`);
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};
